import { useCallback } from 'react';

import { useAlerts } from '@/feature/alerts/hooks/use-alerts';
import BetrAnalytics from '@/feature/analytics/analytics';
import { AnalyticsEvent } from '@/feature/analytics/constants';

type ConfirmReplaceBetslipOptions = {
    title: string;
    description: string;
    replaceLabel: string;
    keepLabel: string;
    // must never reject - InfoSheet has no catch around handlePress and strands its spinner
    onReplace: () => void | Promise<void>;
};

export const useReplaceBetslipConfirmation = () => {
    const { showInfoSheet } = useAlerts();

    const showReplaceBetslipConfirmation = useCallback(
        ({ title, description, replaceLabel, keepLabel, onReplace }: ConfirmReplaceBetslipOptions) => {
            BetrAnalytics.trackProductEvent(AnalyticsEvent.SHOW_REPLACE_LINEUP_MODAL);
            showInfoSheet({
                title,
                description,
                buttonLabel: replaceLabel,
                handlePress: async () => {
                    BetrAnalytics.trackProductEvent(AnalyticsEvent.REPLACE_LINEUP_BUTTON);
                    await onReplace();
                },
                secondaryLabel: keepLabel,
                handleSecondaryPress: () => {
                    BetrAnalytics.trackProductEvent(AnalyticsEvent.KEEP_LINEUP_BUTTON);
                },
            });
        },
        [showInfoSheet]
    );

    return { showReplaceBetslipConfirmation };
};
